import { Injectable } from '@angular/core';
import {LoginService} from './login/login.service';
import { Login } from '../interface/login/login';
import { Observable } from 'rxjs/Observable';
import { UserLogin, User } from '../../component/model/user-login';
import 'rxjs/add/operator/map';
import { CookiesService } from '../../shared/service/cookies/cookies.service';
import { CookiesKey } from '../../shared/enum/http-header-key.enum';
import { error } from 'util';
@Injectable()
export class AuthServiceService {
  loginService : LoginService;
  cookies : CookiesService;
  constructor(loginService : LoginService, cookiesSrv : CookiesService ) { 
    this.loginService = loginService;
    this.cookies = cookiesSrv;
  }
  isLoggedIn () : boolean {
 
   // if(sessionStorage.getItem("log") === null || sessionStorage.getItem("log") === undefined || sessionStorage.getItem("log") ==="N") {
    if(this.cookies.getCookies(CookiesKey.TOKEN.toString()) === '') {
       return false;
    } else {
      return true;
    }
    
  };
  isLoggedOf () : boolean {
   //  if(sessionStorage.getItem("log") === null || sessionStorage.getItem("log") === undefined || sessionStorage.getItem("log") ==="N"|| sessionStorage.getItem("log") ==="") {
    if(this.cookies.getCookies(CookiesKey.TOKEN.toString()) === '') {
       return true;
    } else {
      return false;
    }
  };
  isLock () : boolean {
   //  if(sessionStorage.getItem("log") === null || sessionStorage.getItem("log") === undefined || sessionStorage.getItem("log") ==="N"|| sessionStorage.getItem("log") ==="") {
    if(this.cookies.getCookies(CookiesKey.TOKEN.toString()) === '') {
       return false;
    } else {
      if(this.cookies.getCookies(CookiesKey.TOKEN.toString()) === '') {
          return true;
      } else {
          return false;
      }
      
    }
  };
  getUserRole(): string {
     
     return this.cookies.getCookies(CookiesKey.ROLE.toString());
     
  }
  isAuthorized (module : string) : boolean {
      if(module==="USER") {
        return true;
      } else if(module==="APPOINTMENT") {
        return true;
      } else if(module==="MASTER") {
        return true;
      } else if(module==="REPORT") {
        return true;
      } else if(module==="REPORT") {
        return true;
      } else if(module ==="PATIENT") {
        return true;
      } else if(module ==="PROMOCODE") {
        return true;
      } else if(module ==="VIDEOCONFERENCE") {
        return true;
      } else {
        return false;
      }
     
  };
  
  setLoginDetail(token : string, time : number, name : string) : void {
    this.cookies.setCookies(CookiesKey.TOKEN.toString(),token,time);
    this.cookies.setOtherCookies(CookiesKey.SESSIONTIME.toString(),time.toString(),time);
    this.cookies.setOtherCookies(CookiesKey.USERNAME.toString(),name,time);
  } ; 

  setUserDetail(organization : string, role: string, time : number) : void {
   
    this.cookies.setOtherCookies(CookiesKey.ORGANIZATION.toString(),organization,time);
    this.cookies.setOtherCookies(CookiesKey.ROLE.toString(), role,CookiesKey.EXPIRETIME);
  } ;

  login(data : User)  : Observable<Login> {
     var loginObs : Observable<Login> =  this.loginService.getLogin(data);
     loginObs.subscribe(res=> { this.setLoginDetail(res.access_token, +res.expires_in, data.email)},
     error=> {
        // debugger;
     }
       )
     return loginObs;
  };
 
  logout() : boolean {
      this.cookies.deleteCookie(CookiesKey.TOKEN.toString());
      this.cookies.deleteCookie(CookiesKey.SESSIONTIME.toString());
      this.cookies.deleteCookie(CookiesKey.USERNAME.toString());
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/component/service/auth-service.service.ts